var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.211,
    height: 11.185,
    viewBox: "0 0 22.211 11.185",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_49906",
    "data-name": "Group 49906",
    transform: "translate(1.016 0.739)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44373",
    "data-name": "Group 44373",
    transform: "translate(0.011 0.011)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_88540",
    "data-name": "Path 88540",
    d: "M.75,6.822S4.327.75,10.829.75,20.907,6.822,20.907,6.822",
    transform: "translate(-0.75 -0.75)",
    fill: "none",
    stroke: "#000c1f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_367",
    "data-name": "Ellipse 367",
    cx: 3.612,
    cy: 3.612,
    r: 3.612,
    transform: "translate(6.467 2.461)",
    fill: "none",
    stroke: "#000c1f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eye_icon.58a0f32dcd98011d8db2dedaed7133c0.svg";
export { ForwardRef as ReactComponent };